import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#272525",
  viewBox: "0 0 300 300"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M113.696 156.721 28 135.288v-108.1l85.696 97.698zM113.901 185.955l-56.564 32.279v-46.748l56.564-3.572zM240.283 69.726l16-16.896V27.702l-16 20.661zM195.684 170.733 271 178.998V98.059l-75.316 41.895zM195.658 196.247l24.141 15.975v-23.37l-24.141-7.962zM195.838 126.946l13.44-11.219V85.373l-13.44 18.041zM194.709 205.612h-15.025l22.576 29.833h26.245zM130.703 232.896H98.254L60.866 282h56.14zM171.145 205.677h-26.194l-6.415 56.924h63.467zM133.147 205.677h-18.123l-9.219 10.716h22.98zM140.268 97.287h-25.276L97.946 63.463h37.774zM193.766 97.197h-41.052L156.435 19h87.941z" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M28 19h243v263H28z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }